import React from "react";
import { formatDateTime, primaryContactEmail } from "./utils";

export default function RepliesView({ rows, onOpenLead }) {
  if (!rows?.length) {
    return (
      <div className="flex h-full flex-col items-center justify-center px-6 text-center">
        <p className="text-base font-semibold text-zinc-900">No replies yet</p>
        <p className="mt-1 max-w-sm text-sm text-zinc-500">
          Host replies from Gmail sync will appear here. Only meaningful engagement — replies — is tracked. Opens and clicks are not reported.
        </p>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto bg-zinc-50/40 px-5 py-4">
      <div className="grid gap-2">
        {rows.map((row) => {
          const snippet = (row.activity?.text || "")
            .replace(/\s+/g, " ")
            .trim()
            .slice(0, 220);
          return (
            <button
              key={row.activity._id}
              onClick={() =>
                row.lead
                  ? onOpenLead?.({ lead: row.lead, campaignLead: row.campaignLead })
                  : null
              }
              className="group flex items-start gap-3 rounded-xl border border-zinc-200 bg-white px-4 py-3 text-left shadow-card transition-all hover:-translate-y-0.5 hover:shadow-card-hover"
            >
              <div className="mt-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-emerald-50 text-emerald-600">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" className="h-4 w-4" fill="currentColor">
                  <path d="M8.5 4.5a1 1 0 011.707-.707L15 8.586V5a1 1 0 112 0v6a1 1 0 01-1 1h-6a1 1 0 110-2h3.586l-4.793-4.793A1 1 0 018.5 4.5z" />
                  <path d="M3 15a1 1 0 011-1h12a1 1 0 010 2H4a1 1 0 01-1-1z" />
                </svg>
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-start justify-between gap-2">
                  <p className="truncate text-sm font-semibold text-zinc-900">
                    {row.lead?.company_name || row.activity?.from || "Reply"}
                  </p>
                  <p className="shrink-0 text-xs text-zinc-400 tabular-nums">
                    {formatDateTime(row.activity?.occurredAt)}
                  </p>
                </div>
                <p className="mt-0.5 truncate text-xs text-zinc-500">
                  {row.activity?.subject || "No subject"}
                  {row.lead ? ` · ${primaryContactEmail(row.lead) || ""}` : ""}
                </p>
                <p className="mt-1.5 line-clamp-2 text-sm text-zinc-700">
                  {snippet || "No preview available."}
                </p>
              </div>
              <span className="mt-1 shrink-0 rounded-md bg-indigo-50 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-indigo-700 opacity-0 transition-opacity group-hover:opacity-100">
                Open thread
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
